// removed by extract-text-webpack-plugin
module.exports = {"rafOffer":"G5211d3"};